'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseReducer2 = require('./BaseReducer');

var _BaseReducer3 = _interopRequireDefault(_BaseReducer2);

var _qim = require('qim');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressPopupReducer = function (_BaseReducer) {
  (0, _inherits3.default)(ProgressPopupReducer, _BaseReducer);

  function ProgressPopupReducer() {
    (0, _classCallCheck3.default)(this, ProgressPopupReducer);
    return (0, _possibleConstructorReturn3.default)(this, (ProgressPopupReducer.__proto__ || (0, _getPrototypeOf2.default)(ProgressPopupReducer)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProgressPopupReducer, [{
    key: 'show',
    value: function show(_ref) {
      var state = _ref.state,
          action = _ref.action;

      return (0, _qim.update)([['visible', (0, _qim.$set)(true)], [(0, _qim.$merge)(action.options)]], this._mainReducer(state, action));
    }
  }, {
    key: 'hide',
    value: function hide(_ref2) {
      var state = _ref2.state,
          action = _ref2.action;

      return (0, _qim.set)(['visible'], false, this._mainReducer(state, action));
    }
  }]);
  return ProgressPopupReducer;
}(_BaseReducer3.default);

exports.default = ProgressPopupReducer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/ProgressPopupReducer.js
// module id = 2239
// module chunks = 1